export default __webpack_public_path__ + "static/teamPhoto9-23d2ab87643baaeb112561f473b8cef0.png";